import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { RiUserReceived2Line, RiArrowDownSLine } from "react-icons/ri";
import { GiTwoCoins } from "react-icons/gi";
import { TbDice } from "react-icons/tb";
import { BsBagHeart } from "react-icons/bs";
import { Avatar } from "primereact/avatar";
import { Sidebar } from "primereact/sidebar";
import { Tooltip } from "primereact/tooltip";
import { ProgressBar } from "primereact/progressbar";
import { MegaMenu } from "primereact/megamenu";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { LuFerrisWheel } from "react-icons/lu";

import "../assets/css/Header.css";
import logo from "../assets/images/Shaadilogo.png";
import nouser from "../assets/images/no_user.png";
import Shortcart from "../components/Shortcart";
import { useAuth } from "../context/AuthContext";
import { getSocket } from "../context/socket";
import api from "../api/axios";
import { GiWallet } from "react-icons/gi";

const SHOP_STATE_KEY = "shop_state_v1";

const SHOP_DEFAULT_STATE = {
  category: { category_name: "", category_id: 0 },
  subcategory: null,
  searchTerm: "",
  sortBy: "name_asc",
  first: 0,
  rows: 21,
  occasionId: null,
};

const Header = () => {
  const {
    isAuthenticated,
    userId,
    tierlevel,
    creditlimit,
    imgUrl,
    loading: authLoading,
  } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const socket = getSocket();

  const getSavedShopState = () => {
    try {
      return JSON.parse(localStorage.getItem(SHOP_STATE_KEY)) || {};
    } catch {
      return {};
    }
  };

  const saveShopState = (nextState) => {
    localStorage.setItem(SHOP_STATE_KEY, JSON.stringify(nextState));
    window.dispatchEvent(
      new CustomEvent("shop-state-updated", { detail: nextState })
    );
  };

  const [balance, setBalance] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const [visibleRight, setVisibleRight] = useState(false);
  const [blink, setBlink] = useState(false);

  const [menuItems, setMenuItems] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [hiddenMoreCategories, setHiddenMoreCategories] = useState([]);
  const [morePanelOpen, setMorePanelOpen] = useState(false);
  const [moreActiveCategory, setMoreActiveCategory] = useState(null);

  const [headerCategories, setHeaderCategories] = useState([]);
  const [headerCategory, setHeaderCategory] = useState(null);
  const [headerSearchTerm, setHeaderSearchTerm] = useState(() => {
    return getSavedShopState().searchTerm || "";
  });
  const [isSearchOnly, setIsSearchOnly] = useState(false);

  const getAllCategoryOption = () =>
    headerCategories.find((c) => c.category_name === "") || {
      category_name: "",
      category_id: 0,
    };

  const saveAndNavigateShop = ({
    category = "",
    subcategory = null,
    searchTerm = "",
    replace = false,
    reset = false,
  }) => {
    const selectedCategory = category
      ? headerCategories.find((c) => c.category_name === category) || {
          category_name: category,
        }
      : getAllCategoryOption();

    const nextState = reset
      ? {
          ...SHOP_DEFAULT_STATE,
          category: getAllCategoryOption(),
        }
      : {
          ...getSavedShopState(),
          category: selectedCategory,
          subcategory,
          searchTerm: typeof searchTerm === "string" ? searchTerm.trim() : "",
          first: 0,
        };

    saveShopState(nextState);

    navigate("/shop", {
      state: {
        reset,
        category: reset ? "" : category,
        subcategory: reset ? null : subcategory,
        searchTerm: nextState.searchTerm,
        occasionId: reset ? null : nextState.occasionId,
        sortBy: reset ? "name_asc" : nextState.sortBy,
      },
      replace,
    });
  };



  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScroll && currentScroll > 80) {
        setIsSearchOnly(true);
        setMorePanelOpen(false);
      } else {
        setIsSearchOnly(false);
      }

      setLastScroll(currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScroll]);

  const fetchWalletBalance = async () => {
    try {
      const res = await api.get(`/customerProfileRoutes/customer/wallet`);
      if (res.data?.success) setBalance(res.data.data.balance);
    } catch (err) {
      console.error("Wallet fetch failed", err);
    }
  };

  useEffect(() => {
    if (!isAuthenticated || !socket || !userId) return;

    fetchWalletBalance();

    const handleWalletUpdate = (data) => {
      if (data?.customer_id === userId) {
        setBlink(true);
        fetchWalletBalance();
        setTimeout(() => setBlink(false), 3000);
      }
    };

    socket.on("wallet-updated", handleWalletUpdate);
    return () => socket.off("wallet-updated", handleWalletUpdate);
  }, [socket, userId, isAuthenticated]);

  const percentage = creditlimit ? (balance / creditlimit) * 100 : 0;
  const balanceColor = balance > 20 ? "#C5C5C5" : "#dc3545";

  const handleHeaderSearch = (
    searchValue = headerSearchTerm,
    categoryValue = headerCategory
  ) => {
    saveAndNavigateShop({
      category: categoryValue?.category_name || "",
      subcategory: null,
      searchTerm: searchValue,
    });

    setMobileOpen(false);
  };

  const handleMegaMenuNavigate = (categoryObj, subcategoryName = null) => {
    setHeaderCategory(categoryObj);
    setHeaderSearchTerm("");

    saveAndNavigateShop({
      category: categoryObj?.category_name || "",
      subcategory: subcategoryName,
      searchTerm: "",
      replace: true,
    });

    setMobileOpen(false);
    setMorePanelOpen(false);
  };

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     try {
  //       const res = await api.get(
  //         "/CategoryRoutes/customer/categories-with-subcategories"
  //       );

  //       if (res.data?.success) {
  //         const allCategoryOption = { category_name: "", category_id: 0 };
  //         const headerCategoryList = [allCategoryOption, ...res.data.data];

  //         setHeaderCategories(headerCategoryList);

  //         const saved = getSavedShopState();
  //         const savedCategoryName =
  //           location.state?.reset === true
  //             ? ""
  //             : location.state?.category ?? saved.category?.category_name ?? "";

  //         const selectedHeaderCategory =
  //           headerCategoryList.find(
  //             (cat) => cat.category_name === savedCategoryName
  //           ) || allCategoryOption;

  //         setHeaderCategory(selectedHeaderCategory);
  //         setHeaderSearchTerm(
  //           location.state?.reset === true
  //             ? ""
  //             : location.state?.searchTerm ?? saved.searchTerm ?? ""
  //         );

  //         const formattedMenu = res.data.data.map((category) => ({
  //           label: category.category_name,
  //           items: [
  //             [
  //               {
  //                 items: [
  //                   {
  //                     label: "🔥 Bundles (Best Value)",
  //                     className: "menu-bundle-highlight",
  //                     command: () => {
  //                       setHeaderCategory(
  //                         headerCategoryList.find(
  //                           (cat) =>
  //                             cat.category_name === category.category_name
  //                         ) || allCategoryOption
  //                       );
  //                       setHeaderSearchTerm("");

  //                       navigate("/bulkproductlist", {
  //                         state: { category: category.category_name },
  //                         replace: true,
  //                       });

  //                       setMobileOpen(false);
  //                       setMorePanelOpen(false);
  //                     },
  //                   },
  //                   ...category.subcategories.map((sub) => ({
  //                     label: sub.subcategory_name,
  //                     command: () =>
  //                       handleMegaMenuNavigate(
  //                         category,
  //                         sub.subcategory_name
  //                       ),
  //                   })),
  //                 ],
  //               },
  //             ],
  //           ],
  //         }));

  //         setAllCategories(formattedMenu);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch categories", error);
  //     }
  //   };

  //   fetchCategories();
  // }, [navigate, location.state]);

  useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await api.get(
        "/CategoryRoutes/customer/categories-with-subcategories"
      );

      if (res.data?.success) {
        const allCategoryOption = {
          category_name: "",
          category_id: 0,
        };

        const headerCategoryList = [
          allCategoryOption,
          ...res.data.data,
        ];

        setHeaderCategories(headerCategoryList);

        const saved = getSavedShopState();

        const savedCategoryName =
          location.state?.reset === true
            ? ""
            : location.state?.category ??
              saved.category?.category_name ??
              "";

        const selectedHeaderCategory =
          headerCategoryList.find(
            (cat) =>
              cat.category_name === savedCategoryName
          ) || allCategoryOption;

        setHeaderCategory(selectedHeaderCategory);

        setHeaderSearchTerm(
          location.state?.reset === true
            ? ""
            : location.state?.searchTerm ??
              saved.searchTerm ??
              ""
        );

        const formattedMenu = res.data.data.map(
          (category) => {
            /*
             * Every category must always begin with an "All" option,
             * even when "All" does not exist in the database.
             *
             * If the DB already contains an "All" subcategory,
             * filter it out so the menu never shows it twice.
             */
            const dbSubcategories =
              Array.isArray(
                category.subcategories
              )
                ? category.subcategories.filter(
                    (sub) =>
                      String(
                        sub?.subcategory_name ||
                          ""
                      )
                        .trim()
                        .toLowerCase() !==
                      "all"
                  )
                : [];

            const subcategoryItems = [
              {
                label: "All",

                command: () =>
                  handleMegaMenuNavigate(
                    category,
                    null
                  ),
              },

              ...dbSubcategories.map(
                (sub) => ({
                  label:
                    sub.subcategory_name,

                  command: () =>
                    handleMegaMenuNavigate(
                      category,
                      sub.subcategory_name
                    ),
                })
              ),
            ];

            return {
              label:
                category.category_name,

              items: [
                [
                  {
                    items:
                      subcategoryItems,
                  },
                ],
              ],
            };
          }
        );

        setAllCategories(formattedMenu);
      }
    } catch (error) {
      console.error(
        "Failed to fetch categories",
        error
      );
    }
  };

  fetchCategories();
}, [navigate, location.state]);

  useEffect(() => {
    const handleShopStateUpdated = (event) => {
      const updatedState = event.detail;
      const categoryName = updatedState?.category?.category_name || "";

      const selectedHeaderCategory =
        headerCategories.find((cat) => cat.category_name === categoryName) ||
        headerCategories.find((cat) => cat.category_name === "") ||
        null;

      setHeaderCategory(selectedHeaderCategory);
      setHeaderSearchTerm(updatedState?.searchTerm || "");
    };

    window.addEventListener("shop-state-updated", handleShopStateUpdated);
    return () => {
      window.removeEventListener("shop-state-updated", handleShopStateUpdated);
    };
  }, [headerCategories]);

  useEffect(() => {
    if (!allCategories.length) return;

    const width = window.innerWidth;

    if (width < 1024) {
      setMenuItems(allCategories);
      setHiddenMoreCategories([]);
      return;
    }

    const itemWidth = 140;
    const availableWidth = width - 400;
    const maxItems = Math.floor(availableWidth / itemWidth);
    const limit = Math.max(4, maxItems);

    if (allCategories.length > limit) {
      const visibleItems = allCategories.slice(0, limit);
      const hiddenItems = allCategories.slice(limit);

      setMenuItems(visibleItems);
      setHiddenMoreCategories(hiddenItems);

      if (!moreActiveCategory && hiddenItems.length > 0) {
        setMoreActiveCategory(hiddenItems[0].label);
      }
    } else {
      setMenuItems(allCategories);
      setHiddenMoreCategories([]);
    }
  }, [allCategories, moreActiveCategory]);

  /*----------------mobile_hide search only------------------*/

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes luckyWheelPulse {
            0% {
              transform: scale(1);
              box-shadow:
                0 0 0 0 rgba(255, 113, 188, 0.55),
                0 0 16px rgba(255, 113, 188, 0.20);
            }

            50% {
              transform: scale(1.08);
              box-shadow:
                0 0 0 8px rgba(255, 113, 188, 0),
                0 0 24px rgba(255, 113, 188, 0.42);
            }

            100% {
              transform: scale(1);
              box-shadow:
                0 0 0 0 rgba(255, 113, 188, 0),
                0 0 16px rgba(255, 113, 188, 0.20);
            }
          }

          .header-spin-wheel-btn {
            width: 35px;
            height: 35px;
            min-width: 35px;
            border: 1px solid rgba(255, 173, 216, 0.45);
            border-radius: 50%;
            background: linear-gradient(145deg, rgb(255 221 64 / 18%), rgb(255 221 64 / 9%));
            color: #ffdd40;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            cursor: pointer;
            position: relative;
            isolation: isolate;
            animation: luckyWheelPulse 1.8s ease-in-out infinite;
            transition:
              transform 0.2s ease,
              border-color 0.2s ease,
              background 0.2s ease;
          }

          .header-spin-wheel-btn::before {
            content: "";
            position: absolute;
            inset: -4px;
            border-radius: inherit;
            border: 1px solid rgba(255, 113, 188, 0.24);
            pointer-events: none;
          }

          .header-spin-wheel-btn:hover {
            animation-play-state: paused;
            transform: scale(1.08);
            border-color: #FFADD8;
            background:
              linear-gradient(
                145deg,
                rgba(255, 113, 188, 0.30),
                rgba(255, 173, 216, 0.14)
              );
          }

          .header-spin-wheel-btn:focus-visible {
            outline: 2px solid #FFADD8;
            outline-offset: 3px;
          }

          .header-spin-wheel-btn svg {
            font-size: 22px;
            pointer-events: none;
          }

          @media (prefers-reduced-motion: reduce) {
            .header-spin-wheel-btn {
              animation: none;
            }
          }
        `}
      </style>

      <header
          className={`header show ${
            isSearchOnly && !isMobile ? "search-only" : ""
          }`}
        >
        <div className="header-main-row">
          <Link to={isAuthenticated ? "/home" : "/"} className="logo me-4">
            <img src={logo} alt="Logo" style={{ height: "80px" }} />
          </Link>

          <div className="searchInput">
            <nav
             className={`nav-menu ${mobileOpen ? "open" : ""} ${
                isSearchOnly && !isMobile ? "nav-hidden" : ""
              }`}
            >
              <MegaMenu
                model={menuItems}
                orientation="horizontal"
                className="full-mega"
                autoDisplay={false}
              />

              {hiddenMoreCategories.length > 0 && (
                <div
                  className="custom-more-menu"
                  //onMouseEnter={() => setMorePanelOpen(true)}
                  //onMouseLeave={() => setMorePanelOpen(false)}
                >
                  <button
                    type="button"
                    className="custom-more-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      if (!moreActiveCategory && hiddenMoreCategories.length) {
                        setMoreActiveCategory(hiddenMoreCategories[0].label);
                      }

                      setMorePanelOpen((prev) => !prev);
                    }}
                  >
                    MORE <RiArrowDownSLine />
                  </button>

                  {morePanelOpen && (
                    <div className="custom-more-panel">
                      <div className="custom-more-bg">
                        <div className="custom-more-category-row">
                          {hiddenMoreCategories.map((cat) => (
                            <button
                              key={cat.label}
                              type="button"
                              className={`custom-more-category-tab ${
                                moreActiveCategory === cat.label ? "active" : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setMoreActiveCategory(cat.label);
                              }}
                            >
                              {cat.label}
                            </button>
                          ))}
                        </div>

                        <div className="custom-more-sub-grid">
                          {hiddenMoreCategories
                            .find((cat) => cat.label === moreActiveCategory)
                            ?.items?.[0]?.[0]?.items?.map((item, index) => (
                              <button
                                key={`${item.label}-${index}`}
                                type="button"
                                className={`custom-more-sub ${
                                  item.className || ""
                                }`}
                                onClick={() => {
                                  item.command?.();
                                  setMorePanelOpen(false);
                                  setMobileOpen(false);
                                }}
                              >
                                {item.label}
                              </button>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </nav>

            <div className="header-search-wrap">
              <div className="header-search-box">
                <Dropdown
                  value={headerCategory}
                  options={headerCategories}
                  optionLabel={(cat) =>
                    cat.category_name === "" ? "All" : cat.category_name
                  }
                  onChange={(e) => {
                    setHeaderCategory(e.value);
                    handleHeaderSearch(headerSearchTerm, e.value);
                  }}
                  className="header-search-dropdown"
                />

                <InputText
                  value={headerSearchTerm}
                  placeholder="Search photos..."
                  onChange={(e) => setHeaderSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleHeaderSearch();
                  }}
                  className="header-search-input"
                />

                <Button
                  icon="pi pi-search"
                  className="header-search-btn"
                  onClick={() => handleHeaderSearch()}
                />
              </div>
            </div>
          </div>

          <div className="header-right position-relative">
            <span
              className="loginbtn"
              onClick={() => {
                if (!authLoading && isAuthenticated && Number(tierlevel) > 0) {
                  navigate("/planupdate");
                } else {
                  navigate("/packages");
                }
              }}
            >
              <b className="d-none d-md-none d-lg-block">Pricing</b> 
              <b className="d-block d-md-block d-lg-none" style={{fontSize:'25px', color:'#ffadd8'}}><GiWallet /></b>
            </span>

            {isAuthenticated && (
              <button
                type="button"
                className="header-spin-wheel-btn"
                onClick={() => navigate("/dashboard/spin-wheel")}
                title="Lucky Wheel"
                aria-label="Open Lucky Wheel"
              >
                <LuFerrisWheel />
              </button>
            )}

            {!isAuthenticated && (
              <span className="loginbtn" onClick={() => navigate("/login")} title="SIGN IN">
                <RiUserReceived2Line className="header-icon" /> Sign In
              </span>
            )}

            {isAuthenticated && (
              <div
                className="icon-badge badge-3d-fill custom-tooltip-btn"
                onClick={() => navigate("/dashboard")}
                style={{ cursor: "pointer" }}
              >
                <Avatar image={imgUrl || nouser} shape="circle" />

                <span>
                  <b
                    className={blink ? "balance-blink" : ""}
                    style={{
                      color: balanceColor,
                      fontSize: "17px",
                      fontFamily: "SFPro",
                    }}
                  >
                    {balance}
                  </b>
                </span>

                <small>
                  <GiTwoCoins />
                </small>
              </div>
            )}

            <Tooltip target=".custom-tooltip-btn" position="bottom">
              <div style={{ padding: "10px" }}>
                <ProgressBar
                  value={percentage}
                  showValue={false}
                  style={{
                    height: "6px",
                    borderRadius: "10px",
                    background: "#2d2c2c",
                  }}
                />

                <div className="flex justify-content-between text-sm fw-bold">
                  <span style={{ color: "#faea13" }}>Balance {balance}</span>
                </div>

                <div
                  style={{
                    fontSize: "14px",
                    color: "#a8a8a8",
                    marginTop: "4px",
                  }}
                >
                  Credits Added every month
                </div>
              </div>
            </Tooltip>

            {isAuthenticated && (
              <div className="icon-badge d-lg-block d-none">
                <BsBagHeart
                  className="header-icon"
                  onClick={() => setVisibleRight(true)}
                />
              </div>
            )}

            <div
              className="mobile-menu-icon"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
        </div>
      </header>

      <Sidebar
        className="shortCartSide"
        visible={visibleRight}
        position="right"
        onHide={() => setVisibleRight(false)}
        style={{ width: "80vw" }}
      >
        <Shortcart />
      </Sidebar>
    </>
  );
};

export default Header;